import { navigationFeatureEnabled } from '@app/helpers/navigationFeatureEnabled'

export const COOKIE_SOURCE_URL = 'sourceUrl'
export const COOKIE_REFERRER = 'referrer'

export const getBacktrackCookieName = () => {
  return navigationFeatureEnabled() ? COOKIE_REFERRER : COOKIE_SOURCE_URL
}
